// extracted by mini-css-extract-plugin
export default {"cta":"SF-z","disabled":"TF-z"};